import { MouseEventHandler } from "react";

import { CaptionAlignment, CheckBoxControlDataAttributesProps, DataAttributesProps } from "@multiweb/reactComponents";
import { ControlUtils } from "UI/UI/UI/Controls/ControlUtils";
import { EnumUtils } from "../../../Global/Base/Utils/EnumUtils";
import { EditableControlConnector } from "../EditableControlConnector";

/**
 * Konektor pro napojení komponenty CheckBox do původní multiweb aplikace.
 */
export class CheckBoxControlConnector extends EditableControlConnector {
    /**
     * @inheritDoc
     * @protected
     */
    protected override _getPropsFromDataAttributes(): DataAttributesProps & CheckBoxControlDataAttributesProps {
        return {
            ...super._getPropsFromDataAttributes(),
            alignment: EnumUtils.getEnumValueFromName(CaptionAlignment, ControlUtils.getDataAttr("alignment", this.element)),
        };
    }

    /**
     * @inheritDoc
     */
    public override isFilledPostponedControl(): boolean {
        const isFilledPostponedControl = !(this.postponedRequired && this.controlValue == null && this.visible);

        if (this.multiEditActive) {
            return !this.touched || isFilledPostponedControl;
        }

        return isFilledPostponedControl;
    }

    /**
     * @inheritDoc
     */
    public override isFilledRecommendedControl(): boolean {
        const isFilledRecommendedControl = !(this.recommended && this.controlValue == null);

        if (this.multiEditActive) {
            return !this.touched || isFilledRecommendedControl;
        }

        return isFilledRecommendedControl;
    }

    /**
     * @inheritDoc
     */
    public override isFilledRequiredControl(): boolean {
        const isFilledRequiredControl = !(this.required && this.controlValue == null);

        if (this.multiEditActive) {
            return !this.touched || isFilledRequiredControl;
        }

        return isFilledRequiredControl;
    }

    protected override _handleClick: MouseEventHandler = (e) => {
        if (!this.multiEditActive || this.enabledVisual) {
            this._touched = true;
        }

        this.clicked.trigger(this, e.nativeEvent);
    };
}
